import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';

const SVG = styled.svg`
  position: absolute;
  height: 100%;
  width: auto;
  .cls-1 {
    fill: none;
  }

  .ground-water-resource {
    transform: scale(1, 1);
    transform-origin: 50% 50%;
    transform-box: fill-box;
    opacity: 0;
    transition: transform 200ms ease-in-out, opacity 200ms linear;
    fill: #fff;
    stroke: #000;
    stroke-miterlimit: 10;
    stroke-width: 2px;
    cursor: pointer;

    &.is-active {
      opacity: 1;
    }
  }
`;
const SVGLayer = ({active, setActiveProject}) => {
  function onClick(id, position) {
    setActiveProject(id, position);
  }
  return (
    <SVG id='ground ground-active' viewBox='0 0 1080 1540'>
      <g className='cls-2' transform='translate(124.5 -90.21)'>
        <g
          onClick={() => onClick('sarhan')}
          style={{pointerEvents: 'bounding-box'}}
        >
          <polygon
            id='sarhan'
            className={`ground-water-resource ${
              active === 'sarhan' ? 'is-active' : 'is-hidden'
            }`}
            points='1042.3 1066.41 967.1 991.21 967.1 966.11 891.8 891.01 891.8 865.91 854.1 828.31 854.1 891.01 766.3 978.71 728.7 978.71 640.8 1066.41 590.7 1066.41 628.3 1104.01 628.3 1129.01 665.9 1166.61 665.9 1204.21 703.6 1241.81 728.7 1241.81 753.8 1266.81 753.8 1291.91 741.2 1304.41 741.2 1317.01 753.8 1329.51 753.8 1404.71 816.5 1404.71 967.1 1254.31 1054.9 1254.31 1130.2 1179.11 1042.3 1091.41 1042.3 1066.41'
          />
          <polygon
            id='sarhan'
            className={`ground-water-resource ${
              active === 'sarhan' ? 'is-active' : 'is-hidden'
            }`}
            points='1243.1 615.31 1243.1 577.71 1230.5 565.21 1230.5 540.11 1218 527.61 1218 515.11 1205.5 502.51 1192.9 502.51 1192.9 464.91 1180.4 452.41 1155.3 452.41 1167.8 464.91 1167.8 615.31 1142.7 640.41 1142.7 652.91 1130.2 665.41 1105.1 690.51 1092.5 690.51 1067.4 715.51 1042.3 715.51 992.2 765.71 954.5 765.71 929.4 790.71 891.8 790.71 879.2 803.21 1029.8 803.21 1117.6 715.51 1180.4 715.51 1255.6 640.41 1255.6 627.81 1243.1 615.31'
          />
        </g>
        <polygon
          onClick={() => onClick('disi')}
          id='disi'
          className={`ground-water-resource ${
            active === 'disi' ? 'is-active' : 'is-hidden'
          }`}
          points='515.4 1555.01 515.4 1530.01 502.8 1517.41 502.8 1492.41 477.7 1467.31 339.7 1467.31 339.7 1479.81 314.6 1479.81 302.1 1467.31 302.1 1442.31 289.5 1429.71 289.5 1417.21 251.9 1379.61 226.8 1379.61 164.1 1317.01 164.1 1304.41 151.5 1304.41 139 1317.01 139 1354.51 151.5 1367.11 151.5 1404.71 139 1417.21 139 1479.81 113.9 1504.91 113.9 1542.51 151.5 1580.11 214.3 1580.11 251.9 1617.71 314.6 1617.71 352.3 1655.31 415 1655.31 515.4 1555.01'
        />
        <polygon
          onClick={() => onClick('southern-araba')}
          id='southern-araba'
          className={`ground-water-resource ${
            active === 'southern-araba' ? 'is-active' : 'is-hidden'
          }`}
          points='151.5 1304.41 151.5 1266.81 126.4 1266.81 113.9 1254.31 63.7 1254.31 63.7 1317.01 1 1379.61 1 1479.81 26.1 1479.81 38.6 1492.41 38.6 1530.01 101.3 1530.01 113.9 1542.51 113.9 1504.91 139 1479.81 139 1417.21 151.5 1404.71 151.5 1367.11 139 1354.51 139 1317.01 151.5 1304.41'
        />
        <polygon
          onClick={() => onClick('northern-araba')}
          id='northern-araba'
          className={`ground-water-resource ${
            active === 'northern-araba' ? 'is-active' : 'is-hidden'
          }`}
          points='151.5 978.71 189.2 1016.31 201.7 1028.81 201.7 1078.91 214.3 1091.41 214.3 1129.01 201.7 1141.51 176.6 1141.51 164.1 1154.11 164.1 1204.21 176.6 1216.71 176.6 1241.81 151.5 1266.81 126.4 1266.81 113.9 1254.31 63.7 1254.31 63.7 1204.21 101.3 1166.61 101.3 1078.91 151.5 1028.81 151.5 978.71'
        />
        <polygon
          onClick={() => onClick('jafer')}
          id='jafer'
          className={`ground-water-resource ${
            active === 'jafer' ? 'is-active' : 'is-hidden'
          }`}
          points='214.3 1104.01 402.5 1104.01 427.6 1078.91 527.9 1078.91 540.5 1066.41 590.7 1066.41 628.3 1104.01 628.3 1129.01 665.9 1166.61 665.9 1204.21 703.6 1241.81 728.7 1241.81 753.8 1266.81 753.8 1291.91 741.2 1304.41 741.2 1317.01 753.8 1329.51 753.8 1404.71 665.9 1404.71 515.4 1555.01 515.4 1530.01 502.8 1517.41 502.8 1492.41 477.7 1467.31 339.7 1467.31 339.7 1479.81 314.6 1479.81 302.1 1467.31 302.1 1442.31 289.5 1429.71 289.5 1417.21 251.9 1379.61 226.8 1379.61 164.1 1317.01 164.1 1304.41 151.5 1304.41 151.5 1266.81 176.6 1241.81 176.6 1216.71 164.1 1204.21 164.1 1154.11 176.6 1141.51 201.7 1141.51 214.3 1129.01 214.3 1104.01'
        />
        <polygon
          onClick={() => onClick('hammad')}
          id='hammad'
          className={`ground-water-resource ${
            active === 'hammad' ? 'is-active' : 'is-hidden'
          }`}
          points='1255.6 640.41 1255.6 627.81 1243.1 615.31 1243.1 577.71 1230.5 565.21 1230.5 540.11 1218 527.61 1218 515.11 1205.5 502.51 1192.9 502.51 1192.9 464.91 1180.4 452.41 1167.8 452.41 1130.2 452.41 1105.1 427.41 1092.5 427.41 1067.4 402.31 1054.9 402.31 992.2 339.71 979.6 339.71 942 302.11 916.9 302.11 1017.3 201.81 1054.9 201.81 1155.3 101.61 1192.9 101.61 1293.3 1.41 1330.9 38.91 1330.9 101.61 1381.1 151.71 1381.1 201.81 1456.4 277.01 1418.7 314.61 1456.4 352.21 1519.1 289.51 1556.8 327.11 1531.7 352.21 1581.9 402.31 1581.9 427.41 1468.9 540.11 1418.7 540.11 1343.5 615.31 1280.7 615.31 1255.6 640.41'
        />
        <polygon
          onClick={() => onClick('jordan-river-side')}
          id='jordan-river-side'
          className={`ground-water-resource ${
            active === 'jordan-river-side' ? 'is-active' : 'is-hidden'
          }`}
          points='226.8 678.01 302.1 678.01 327.2 652.91 327.2 602.81 302.1 577.71 302.1 565.21 289.5 552.71 277 552.71 264.4 540.11 264.4 490.01 277 477.51 289.5 477.51 302.1 464.91 302.1 439.91 314.6 427.41 314.6 352.21 289.5 327.11 277 327.11 264.4 314.61 239.4 314.61 251.9 327.11 251.9 527.61 239.4 540.11 239.4 627.81 226.8 640.41 226.8 678.01'
        />
        <polygon
          onClick={() => onClick('jordan-river')}
          id='jordan-river'
          className={`ground-water-resource ${
            active === 'jordan-river' ? 'is-active' : 'is-hidden'
          }`}
          points='201.7 665.41 214.3 678.01 226.8 678.01 226.8 640.41 239.4 627.81 239.4 540.11 251.9 527.61 251.9 327.11 239.4 314.61 214.3 339.71 214.3 427.41 226.8 439.91 226.8 540.11 214.3 552.71 214.3 652.91 201.7 665.41'
        />
        <polygon
          onClick={() => onClick('yarmouk')}
          id='yarmouk'
          className={`ground-water-resource ${
            active === 'yarmouk' ? 'is-active' : 'is-hidden'
          }`}
          points='490.3 377.21 452.6 377.21 440.1 389.81 389.9 389.81 377.4 377.21 352.3 377.21 339.7 389.81 314.6 389.81 314.6 352.21 289.5 327.11 277 327.11 264.4 314.61 239.4 314.61 277 277.01 364.8 277.01 440.1 352.21 465.2 352.21 490.3 377.21'
        />
        <polygon
          onClick={() => onClick('amman-zarqa')}
          id='amman-zarqa'
          className={`ground-water-resource ${
            active === 'amman-zarqa' ? 'is-active' : 'is-hidden'
          }`}
          points='703.6 452.41 703.6 477.51 691 490.01 691 515.11 678.5 527.61 678.5 552.71 665.9 565.21 665.9 577.71 640.8 602.81 615.8 602.81 603.2 615.31 578.1 615.31 565.6 627.81 527.9 627.81 515.4 640.41 477.7 640.41 465.2 652.91 402.5 652.91 389.9 640.41 364.8 640.41 352.3 627.81 327.2 627.81 327.2 602.81 302.1 577.71 302.1 565.21 289.5 552.71 277 552.71 264.4 540.11 264.4 490.01 277 477.51 289.5 477.51 302.1 464.91 302.1 439.91 314.6 427.41 314.6 389.81 339.7 389.81 352.3 377.21 377.4 377.21 389.9 389.81 440.1 389.81 452.6 377.21 490.3 377.21 565.6 452.41 703.6 452.41'
        />
        <polygon
          onClick={() => onClick('deadsea')}
          id='deadsea'
          className={`ground-water-resource ${
            active === 'deadsea' ? 'is-active' : 'is-hidden'
          }`}
          points='352.3 627.81 352.3 640.41 364.8 652.91 364.8 678.01 377.4 690.51 377.4 778.21 389.9 790.71 389.9 803.21 377.4 815.81 377.4 928.51 364.8 941.11 364.8 991.21 377.4 1003.71 377.4 1053.81 352.3 1078.91 327.2 1078.91 302.1 1104.01 214.3 1104.01 214.3 1091.41 201.7 1078.91 201.7 1028.81 151.5 978.71 151.5 828.31 176.6 803.21 176.6 740.61 214.3 703.01 214.3 678.01 302.1 678.01 327.2 652.91 327.2 627.81 352.3 627.81'
        />
        <polygon
          onClick={() => onClick('azraq')}
          id='azraq'
          className={`ground-water-resource ${
            active === 'azraq' ? 'is-active' : 'is-hidden'
          }`}
          points='879.2 302.11 916.9 302.11 942 302.11 979.6 339.71 992.2 339.71 1054.9 402.31 1067.4 402.31 1092.5 427.41 1105.1 427.41 1130.2 452.41 1155.3 452.41 1167.8 464.91 1167.8 615.31 1142.7 640.41 1142.7 652.91 1105.1 690.51 1092.5 690.51 1067.4 715.51 1042.3 715.51 992.2 765.71 954.5 765.71 929.4 790.71 891.8 790.71 879.2 803.21 829.1 803.21 854.1 828.31 854.1 891.01 766.3 978.71 728.7 978.71 640.8 1066.41 540.5 1066.41 527.9 1078.91 427.6 1078.91 402.5 1104.01 302.1 1104.01 327.2 1078.91 352.3 1078.91 377.4 1053.81 377.4 1003.71 364.8 991.21 364.8 941.11 377.4 928.51 377.4 815.81 389.9 803.21 389.9 790.71 377.4 778.21 377.4 690.51 364.8 678.01 364.8 652.91 352.3 640.41 352.3 627.81 364.8 640.41 389.9 640.41 402.5 652.91 465.2 652.91 477.7 640.41 515.4 640.41 527.9 627.81 565.6 627.81 578.1 615.31 603.2 615.31 615.8 602.81 640.8 602.81 665.9 577.71 665.9 565.21 678.5 552.71 678.5 527.61 691 515.11 691 490.01 703.6 477.51 703.6 452.41 728.7 452.41 879.2 302.11'
        />
      </g>
    </SVG>
  );
};

SVGLayer.propTypes = {
  active: PropTypes.string,
  setActiveProject: PropTypes.func,
};

export default SVGLayer;
